// LEGACY: Uses SCSS with CSS modules. New code should use @metarouter-private/mr-mui components instead.
// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import pt from 'prop-types';

import s from './index.module.scss';

import { Stack, Typography } from '@metarouter-private/mr-mui';

import { MrTable, MrAppMain, MrTwoPaneLayout } from '@ion/components';

import IntegrationName from 'app/components/integrations/IntegrationName';

import OverviewTableRow from './OverviewTableRow';
import StarterKitVersion from './StarterKitVersion';
import IntegrationId from './IntegrationId';
import Created from './Created';
import AssignedPipelinesTable from './AssignedPipelinesTable';
import PipelineRevisionToolTip from './PipelineRevisionToolTip';

const TYPOGRAPHY_HEADER_PROPS = {
  variant: 'h5',
  component: 'h2',
  gutterBottom: true,
};

const Overview = ({ integration, playbook }) => {
  return (
    <MrTwoPaneLayout
      className={s.overviewPanes}
      paneOneClassName={s.paneOneReduced}
      paneOne={
        <>
          <Typography {...TYPOGRAPHY_HEADER_PROPS} data-test-id="DetailsPaneTitle">
            Details
          </Typography>
          <MrTable className={s.details} testId="DetailsTable">
            <tbody>
              <OverviewTableRow firstCell="Created" secondCell={<Created createdAt={integration.createdAt} />} />
              <OverviewTableRow
                firstCell="Integration"
                secondCell={<IntegrationName id={integration.starterkitId} />}
              />
              <OverviewTableRow
                firstCell="Integration ID"
                secondCell={<IntegrationId integrationId={integration.id} />}
              />
              <OverviewTableRow
                firstCell="Starter Kit Version"
                secondCell={<StarterKitVersion starterkitVersion={playbook.version} />}
              />
            </tbody>
          </MrTable>
        </>
      }
      paneTwo={
        <MrAppMain>
          <Stack direction="row" useFlexGap spacing={1} alignItems="center">
            <Typography {...TYPOGRAPHY_HEADER_PROPS} data-test-id="AssignedPipelinesPaneTitle">
              Assigned Pipelines
            </Typography>
            <PipelineRevisionToolTip />
          </Stack>

          <div className={s.scrollable}>
            <div className={s.assigned}>
              <AssignedPipelinesTable playbooks={integration.playbooks} />
            </div>
          </div>
        </MrAppMain>
      }
    />
  );
};

Overview.propTypes = {
  integration: pt.object.isRequired,
  playbook: pt.object,
};
export default Overview;
